import React, { useState } from 'react';
import { arrayOf, func, number, shape } from 'prop-types';
import { Link, useParams } from 'react-router-dom';
// Utils

// Components
import { ChevronRightRounded } from '@mui/icons-material';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MinuteChip from './MinuteChip';

// Styles
import {
  chevronRightStyles,
  labelWrapperStyles,
  linkActiveStyles,
  linkStyles,
  sortBlockStyles,
  timeBlockStyles,
} from './Selector.styles';

const Selector = ({
  data,
  index,
  activeLocation,
  setActiveLocation,
  setActiveTab,
  setMobileDrawerOpen,
}) => {
  const theme = useTheme();
  const { selectorsData } = data;
  const { currentAffiliateId, dataCompanyId } = useParams();

  const mdUp = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  // Hovered state so minute chips can show proper coloring
  const [isHovered, setIsHovered] = useState(false);

  const isActive = activeLocation?.name === selectorsData[index].name || isHovered;
  const handleClick = () => {
    setActiveLocation(selectorsData[index]);
    setActiveTab('waitTimes');
    setMobileDrawerOpen(true);
  };

  return (
    <Link
      key={selectorsData[index].locationId}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={isActive ? linkActiveStyles(theme) : linkStyles(theme)}
      to={`/affiliate/${currentAffiliateId}/${dataCompanyId}/loading-management/terminal-information/rack-wait-times/${selectorsData[index].nameShort}`}
    >
      <Box key={selectorsData[index].locationId} sx={sortBlockStyles}>
        <Box sx={labelWrapperStyles}>
          <Typography
            sx={{
              color: 'text.primary',
              overflow: mdUp ? 'hidden' : 'initial',
              paddingTop: '2px',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              width: 185,
            }}
            variant="body1"
          >
            {selectorsData[index].nameShort}
          </Typography>
          {!mdUp && <ChevronRightRounded sx={chevronRightStyles} />}
        </Box>
        <Box sx={timeBlockStyles}>
          {selectorsData[index]?.waitTimes.map(({ key, minutes }) => (
            <MinuteChip active={isActive} data={minutes} key={key} time={key} />
          ))}
        </Box>
      </Box>
    </Link>
  );
};

Selector.propTypes = {
  activeLocation: shape({}),
  data: shape({
    selectorsData: arrayOf(shape({})),
  }).isRequired,
  index: number.isRequired,
  setActiveLocation: func.isRequired,
  setActiveTab: func.isRequired,
  setMobileDrawerOpen: func.isRequired,
};

Selector.defaultProps = {
  activeLocation: {},
};

export default Selector;
